<div class="title">
    <div>Custom Segmentation</div>
    <button class="wiki-btn" (click)="goToWiki()">?</button>
</div>
<form class="job-selection-dialog-content">
    <cds-form-group layout="vertical">
        <cds-select>
            <label>Task</label>
            <select
                name="task-selection"
                [ngModel]="selectedTask"
                (ngModelChange)="selectedTask = $event; onTaskChange()"
            >
                <option [ngValue]="null">Select a task...</option>
                <option *ngFor="let opt of taskOptions" [ngValue]="opt.value">{{ opt.label }}</option>
            </select>
        </cds-select>
        <div *ngIf="isOtherTask" class="task-custom-row">
            <label class="task-custom-label">Task name</label>
            <input
                type="text"
                class="task-custom-input"
                [(ngModel)]="customTaskName"
                name="customTaskName"
                placeholder="Type custom task name..."
            />
        </div>

        <ng-container *ngIf="selectedTask === SegmentationType.Cell">
            <div class="layer-select-grid">
                <div class="layer-select-row">
                    <label class="layer-select-label">Membrane</label>
                    <span class="layer-summary">{{ getLayersSummary(selectedMembraneLayers) }}</span>
                    <cds-button class="layer-select-btn" size="sm" action="outline" (click)="openLayerListDialog('membrane', 'Select membrane layers')">
                        Select layers
                    </cds-button>
                </div>
                <div class="layer-select-row">
                    <label class="layer-select-label">Nucleus (optional)</label>
                    <span class="layer-summary">{{ getLayersSummary(selectedNucleusLayers) }}</span>
                    <cds-button class="layer-select-btn" size="sm" action="outline" (click)="openLayerListDialog('nucleus', 'Select nucleus layers')">
                        Select layers
                    </cds-button>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="selectedTask && selectedTask !== SegmentationType.Cell">
            <div class="layer-select-grid">
                <div class="layer-select-row">
                    <label class="layer-select-label">Input channels</label>
                    <span class="layer-summary">{{ getLayersSummary(selectedChannelLayers) }}</span>
                    <cds-button class="layer-select-btn" size="sm" action="outline" (click)="openLayerListDialog('channel', 'Select input channel layers')">
                        Select layers
                    </cds-button>
                </div>
            </div>
        </ng-container>

        <div *ngIf="selectedTask" class="description-row">
            <label class="description-label">Description (optional)</label>
            <textarea
                class="description-input"
                [(ngModel)]="description"
                name="description"
                placeholder="Explain or add notes..."
                rows="3"
            ></textarea>
        </div>

        <div *ngIf="siblingDatasets!.length > 1">
            <cds-checkbox>
                <label>Run the job on datasets in the same folder</label>
                <input
                    id="runBatchJob"
                    type="checkbox"
                    name="runBatchJob"
                    [(ngModel)]="runBatchJob"
                />
            </cds-checkbox>
            <ul class="batch-datasets" [class.show]="runBatchJob">
                <li *ngFor="let dataset of siblingDatasets">
                    {{ dataset }}
                </li>
            </ul>
        </div>
    </cds-form-group>
</form>
<div class="actions action-buttons">
    <cds-button size="sm" action="flat" (click)="cancel()">Cancel</cds-button>
    <cds-button size="sm" (click)="startJob()" [disabled]="!canStart">Start job</cds-button>
</div>
